import script from "./ConfirmDeletingProject.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDeletingProject.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmDeletingProject.vue?vue&type=style&index=0&id=79b81d5a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b81d5a"]])

export default __exports__